// =============================================================================
// SimSense Platform — Remote Logger Utility
// =============================================================================
// Sends logs to the backend for runtime observability.
// Helps agents diagnose issues in the desktop WebView without screenshots.

type LogLevel = "info" | "warn" | "error";

/**
 * Sends a log entry to the backend API.
 */
export async function remoteLog(message: string, level: LogLevel = "info", context: any = {}) {
  try {
    // Only log to backend if in production or specifically requested
    // (In dev, console.log is usually enough for local testing)
    console[level](`[REMOTE] ${message}`, context);

    await fetch("/api/debug/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message,
        level,
        context: {
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
          ...context,
        },
      }),
    });
  } catch (err) {
    // Fail silently to avoid infinite loops if the log call itself fails
    console.error("Failed to send remote log", err);
  }
}
